import React, { Component } from 'react';
import { Tag } from 'antd';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

import { sendSegment } from 'utils/segment';
import { TAG_METHODS } from 'constants/settings';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as CheckIcon } from 'assets/bosta-icons/Check.svg';

import './CopyableText.less';

class CopyableText extends Component {
  state = {
    isCopied: false
  };
  copyToClipboard = (e) => {
    const { segment } = this.props;
    if (segment) {
      sendSegment(segment);
    }
    this.textToCopy.select();
    document.execCommand('copy');
    this.setState({
      isCopied: true
    });
    setTimeout(() => this.setState({ isCopied: false }), 2000);
  };

  render() {
    const {
      value,
      isTextArea = false,
      method = null,
      capText = false,
      connectPluginStyle
    } = this.props;
    const { isCopied } = this.state;
    const { intl } = this.props;
    return (
      <div
        className={classnames('br-api__copyable-text', {
          'br-api-copyable-text-area': isTextArea,
          'br-api-copyable-text-with-tag': method,
          'br-api-copyable-text-cap-input': capText,
          'br-api-copyable-text-connectPlugin': connectPluginStyle
        })}
      >
        {isTextArea ? (
          <textarea
            ref={(text) => (this.textToCopy = text)}
            rows="10"
            value={JSON.stringify(value, undefined, 4)}
            readOnly
          />
        ) : (
          <>
            {method && (
              <Tag className={TAG_METHODS[method].className}>
                {TAG_METHODS[method].titleKey}
              </Tag>
            )}

            <input
              ref={(text) => (this.textToCopy = text)}
              value={value}
              readOnly
            />
          </>
        )}

        <div
          className={`br-api__copyable-action ${
            connectPluginStyle && 'br-api__connect-plugin-copyable-action'
          }`}
        >
          {isCopied ? (
            <span
              className={classnames('br-api__copyable-action__copied', {
                'br-api__copyable-action-connect-plugin__copied':
                  connectPluginStyle
              })}
            >
              {connectPluginStyle && <CheckIcon />}
              <span>
                {intl.formatMessage({
                  id: 'settings.api_integration.copied'
                })}
              </span>
            </span>
          ) : (
            <BRButton
              onClick={this.copyToClipboard}
              label={intl.formatMessage({
                id: 'settings.api_integration.copy'
              })}
              className={
                connectPluginStyle && `br-api__copyable-action-connect-plugin`
              }
            />
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(CopyableText);
